// base_info_view 1 
import React, { useRef, useState, useEffect } from 'react'
 
import BaseViewModeSwitch1 from './base_view_mode_switch_1'
import { LayoutGrid, List } from "lucide-react"

import {  } from 'react-bootstrap'
const BaseInfoView2_1 = ({
    button_data = [
        {
            label: "卡片模式",
            icon: <LayoutGrid className="h-4 w-4" />,
            key: "卡片模式"
        },
        {
            label: "列表模式",
            icon: <List className="h-4 w-4" />,
            key: "列表模式"
        }
    ],
    defaultActiveKey = null,
    onChange = () => { }
}) => {

    return (<BaseViewModeSwitch1
         button_data ={button_data}
         defaultActiveKey={defaultActiveKey}
         onChange={onChange}
    />)
}
export default BaseInfoView2_1
